import React from "react";
import LoadingSpinner from "../Utils/LoadingSpinner";
import OrderStatus from "./OrderStatus";

class OrdersList extends React.Component {

    // State of this component
    state = {
        loading: true, // will be true when ajax request is running
        result: null,
    };

    componentDidMount() {
        this.props.simGps.getOrderList(this.gotOrderList);
    }

    gotOrderList = (success, result) => {
        if( success ) {
            const order_completed = (result.status === 'succeeded') ||
                ((result.status === 'failed'));
            this.setState({
                loading: false,
                result: result,
                order_completed: order_completed}
            );

        }else {
            console.log(JSON.stringify(result));
            result = {
                success: false,
                message: JSON.stringify(result)
            };
            this.setState({loading: false, result: result});
        }
    };

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving order status ..."/>);
        } else {
            // Sort most recent first
            const sorted_orders = this.state.result.orders.sort( (a,b) => (b.modified_at - a.modified_at));
            const orders = sorted_orders.map( (order, i) => (
                <OrderStatus
                    {...order} key={i}
                />
                )
            );

            return (
                <div>
                    {orders}
                </div>
            )
        }

    }
}

export default OrdersList;
